<template>
  <vs-popup title="Reiniciar Campanha" :active.sync="isActive" @close="close()">
    <div class="d-flex flex-column" style="gap:16px; padding:10px;">
      <div v-if="!selectedCampaign">
        <label style="font-size: 13px; font-weight: 500; margin-bottom: 8px; display: block;">
          Selecione a Campanha
        </label>

        <vs-select
          v-model="selectedCampaignId"
          placeholder="Escolha uma campanha"
          style="width:100%;"
          :disabled="loadingCampaigns"
        >
          <vs-select-item
            :key="campaign.id"
            :value="campaign.id"
            :text="campaignOptionLabel(campaign)"
            v-for="campaign in campaigns"
          />
        </vs-select>
        
        <div class="d-flex justify-end" style="margin-top: 16px;">
          <vs-button type="filled" @click="selectCampaign" :disabled="!selectedCampaignId || loadingCampaigns">
            Continuar
          </vs-button>
        </div>
      </div>

      <div v-if="selectedCampaign" class="campaign-config">
        <div class="campaign-info">
          <h4>Campanha Selecionada: {{ selectedCampaign.name }}</h4>
        </div>

        <div class="d-flex" style="gap:16px;">
          <div style="flex:1;">
            <label style="font-size: 13px; font-weight: 500; margin-bottom: 8px; display: block;">
              Intervalo (minutos)
            </label>
            <vs-input-number
              v-model="minutes"
              :min="1"
              style="width:100%;"
            />
          </div>

          <div style="flex:1;">
            <label style="font-size: 13px; font-weight: 500; margin-bottom: 8px; display: block;">
              Mensagens por lote
            </label>
            <vs-input-number
              v-model="messages"
              :min="1"
              style="width:100%;"
            />
          </div>
        </div>

        <div class="w-full mt-4 mb-4 flex justify-center items-center flex-direction-row">
          <div class="w-3/12 flex justify-center items-center" style="flex-direction: column;">
            <div class="w-full flex justify-center items-center">
              <span class="phone-number-span mr-8 flex justify-center items-center flex-direction-row" style="font-size: .8rem !important;">
                <vs-radio v-model="sendingType" vs-name="sendingType" vs-value="now">
                  Envio Imediato
                </vs-radio>
              </span>
            </div>
          </div>

          <div class="w-3/12 flex justify-center items-center" style="flex-direction: column;">
            <div class="w-full flex justify-center items-center">
              <span class="phone-number-span ml-8 flex justify-center items-center flex-direction-row" style="font-size: .8rem !important;">
                <vs-radio v-model="sendingType" vs-name="sendingType" vs-value="schedule">
                  Selecionar Data e Horário
                </vs-radio>
              </span>
            </div>
          </div>
        </div>

        <div v-if="sendingType === 'schedule'" class="w-full mt-4 mb-4 flex justify-center items-center flex-direction-row">
          <div class="flex justify-center items-center mr-12" style="flex-direction: column;">
            <div class="w-full flex justify-center items-center">
              <span class="phone-number-span">
                Data Inicial de Envio
              </span>
            </div>

            <div class="w-full flex justify-center items-center">
              <flat-pickr
                :config="configDatePicker"
                v-model="dateStartAt"
                placeholder="Escolha uma Data"
              />
            </div>
          </div>
        </div>

        <div v-if="sendingType === 'schedule'" class="w-full mt-4 mb-4 flex justify-center items-center flex-direction-row">
          <div class="flex justify-center items-center mr-12" style="flex-direction: column;">
            <div class="w-full flex justify-center items-center">
              <span class="phone-number-span">
                Horário Inicial de Envio
              </span>
            </div>

            <div class="w-full flex justify-center items-center">
              <flat-pickr
                :config="configDateTimePicker"
                v-model="startAt"
                placeholder="Escolha um Horário"
              />
            </div>
          </div>

          <div class="flex justify-center items-center ml-12" style="flex-direction: column;">
            <div class="w-full flex justify-center items-center">
              <span class="phone-number-span">
                Horário Final de Envio
              </span>
            </div>

            <div class="w-full flex justify-center items-center">
              <flat-pickr
                :config="finishAtConfig(configDateTimePicker)"
                v-model="finishAt"
                placeholder="Escolha um Horário"
                :disabled="startAt === null"
              />
            </div>
          </div>
        </div>

        <div class="d-flex justify-end" style="gap:8px; margin-top: 16px;">
          <vs-button type="border" @click="cancelSelection">
            Voltar
          </vs-button>
          <vs-button type="filled" @click="restartCampaign" :disabled="disableRestart">
            Reiniciar Disparos
          </vs-button>
        </div>
      </div>
    </div>
  </vs-popup>
</template>

<script>
import {mapGetters} from 'vuex';
import 'flatpickr/dist/flatpickr.css';
import flatPickr from 'vue-flatpickr-component';
import {Portuguese} from 'flatpickr/dist/l10n/pt.js';

export default {
  name: 'RestartCampaign',
  components: {flatPickr},
  props: {
    isActive: {
      type: Boolean,
      default: false
    },
    tenantName: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapGetters(['token']),
    disableRestart() {
      if (this.sendingType === 'now') { return !this.minutes || !this.messages; }
      return !this.minutes || !this.messages || !this.startAt || !this.finishAt ||  this.startAt === null || this.finishAt === null;
    },
    configDateTimePicker() {
      return {
        enableTime: true,
        noCalendar: true,
        time_24hr: true,
      };
    },
    configDatePicker() {
      return {
        enableTime: false,
        noCalendar: false,
        dateFormat: "Y-m-d",
        locale: Portuguese,
        minDate: new Date()
      };
    }
  },
  data() {
    return {
      campaigns: [],
      loadingCampaigns: false,
      selectedCampaignId: null,
      selectedCampaign: null,
      sendingType: 'now',
      minutes: 1,
      messages: 2,
      dateStartAt: null,
      startAt: null,
      finishAt: null,
      datetimepickr: {
        enableTime: true,
        noCalendar: false,
        dateFormat: "Y-m-d H:i:S",
        time_24hr: true,
        locale: Portuguese
      }
    }
  },
  methods: {
    campaignOptionLabel(campaign) {
      const name = campaign.name || '—';
      const creator =
        (campaign.user && campaign.user.name) ||
        campaign.createdByUserName ||
        campaign.userName ||
        campaign.creatorName ||
        '—';
      const connection =
        (campaign.instance && campaign.instance.name) ||
        campaign.connectionName ||
        campaign.whatsappConnectionName ||
        campaign.whatsappName ||
        '—';
      return `${name} | ${creator} | ${connection}`;
    },
    close() {
      this.campaigns = [];
      this.selectedCampaignId = null;
      this.selectedCampaign = null;
      this.minutes = 1;
      this.messages = 2;
      this.startAt = null;
      this.finishAt = null;
      this.dateStartAt = null;
      this.sendingType = 'now';
      this.$emit('isActiveFalse');
    },
    finishAtConfig(config) {
      return {
        ...config,
        minDate: this.startAt
      }
    },
    loadCampaigns() {
      this.loadingCampaigns = true;
      this.$store.dispatch('getCampaigns', {
        type: 0,
        page: 1,
        limit: 10,
        searchQuery: '',
        orderQuery: 'id;DESC',
        tenantName: this.tenantName,
        token: this.token
      }).then(response => {
        this.campaigns = response.data.items || [];
        this.loadingCampaigns = false;
      }).catch(exception => {
        console.error(exception);
        this.loadingCampaigns = false;
        this.$vs.notify({
          color: 'danger',
          title: 'Erro!',
          text: 'Ocorreu um erro ao carregar as campanhas! Entre em contato com o time técnico.'
        });
      });
    },
    selectCampaign() {
      this.selectedCampaign = this.campaigns.find(c => c.id === this.selectedCampaignId);
    },
    cancelSelection() {
      this.selectedCampaign = null;
      this.selectedCampaignId = null;
      this.sendingType = 'now';
      this.minutes = 1;
      this.messages = 2;
      this.dateStartAt = null;
      this.startAt = null;
      this.finishAt = null;
    },
    restartCampaign() {
      const startAt = this.sendingType === 'now' ? null : `${this.dateStartAt} ${this.startAt}`;
      const finishAt = this.sendingType === 'now' ? null : `${this.dateStartAt} ${this.finishAt}`;

      this.$store.dispatch('restartCampaign', {
        campaignId: this.selectedCampaign.id,
        minutes: this.minutes,
        messages: this.messages,
        startAt: startAt,
        finishAt: finishAt,
        tenantName: this.tenantName,
        token: this.token
      }).then(response => {
        this.close();
        this.$vs.notify({
          color: 'success',
          title: 'Sucesso!',
          text: `Campanha "${response.data.name}" reiniciada com sucesso!`
        });
      }).catch(exception => {
        console.error(exception);

        if (exception.response && exception.response.data.errors && exception.response.data.errors[0].message){
          return this.$vs.notify({
            color: 'danger',
            title: 'Erro!',
            text: exception.response.data.errors[0].message
          });
        }

        this.$vs.notify({
          color: 'danger',
          title: 'Erro!',
          text: 'Ocorreu um erro ao reiniciar a campanha! Entre em contato com o time técnico.'
        });
      });
    }
  },
  watch: {
    isActive(value) {
      if (value) {
        this.loadCampaigns();
      } else {
        this.campaigns = [];
        this.selectedCampaignId = null;
        this.selectedCampaign = null;
        this.sendingType = 'now';
        this.minutes = 1;
        this.messages = 2;
        this.dateStartAt = null;
        this.startAt = null;
        this.finishAt = null;
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.d-flex {
  display: flex;
}

.flex-column {
  flex-direction: column;
}

.justify-end {
  justify-content: flex-end;
}

.campaign-config {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.campaign-info {
  background: #f5f5f5;
  border-radius: 8px;
  padding: 12px;
  
  h4 {
    font-size: 14px;
    font-weight: 600;
    color: #333;
    margin: 0;
  }
}
</style>
